export const TICKER_ITEMS = [
  "WINAZ đang diễn ra sự kiện đua top nhận VF3",
  "Cổng game AI đến từ Macau",
  "Cổng game Blockchain",
];

export const GAME_LABEL_PREFIX = "Game chơi thử:";
export const GAME_LABEL_VALUE = "XÓC ĐĨA LIVE";

export const LIVE_NOTICE_TEXT = "Dealer Trường con đang live trực tiếp";

export const SUBTEXT_LINE_1 = "Chơi là thử, thưởng là thật.";
export const SUBTEXT_LINE_2_PREFIX = "Xóc hay - Ăn may, trúng đến ";
export const SUBTEXT_LINE_2_HIGHLIGHT = "888K TIỀN THƯỞNG.";

export const SIDE_LABEL_LEFT = "NỀN TẢNG UY TÍN HÀNG ĐẦU";
export const SIDE_LABEL_RIGHT = "GAME MỚI CẬP NHẬT LIÊN TỤC";

export const FEATURE_CARDS_ALT = [
  "Nạp Rút 1 Phút",
  "CSKH 24/7",
  "Đập Bát, Đốt Vía",
];

// TODO: nhận game thật từ team Cocos, thay cho khu vực placeholder ở bước 2.
export const GAME_IFRAME_URL = "";

// Text baked sẵn trong asset typo1.png, chỉ dùng cho alt.
export const GAME_STAGE_HEADLINE_ALT = "Thử sức 3 tay - Nhận Ngay 88K!";

export const ONLINE_BADGE_SUFFIX = "người đang chơi Xóc Đĩa Live";

// Danh sách proof trúng thưởng hiển thị luân phiên ở bước 2 — tham khảo
// logic từ Home-Winaz-3 (NOTI_ITEMS + shuffle-bag scheduler).
export type ProofItem = {
  id: number;
  username: string;
  prize: string;
};

export const PROOF_ITEMS: ProofItem[] = [
  { id: 1, username: "NAOKIQUACH", prize: "5.123.000" },
  { id: 2, username: "Taixiu***pro", prize: "2.800.000" },
  { id: 3, username: "Dragon***88", prize: "12.500.000" },
  { id: 4, username: "Namkute***4", prize: "980.000" },
  { id: 5, username: "Longdaica***", prize: "6.250.000" },
  { id: 6, username: "Xocdia***vip", prize: "3.410.000" },
  { id: 7, username: "Minhkhang***", prize: "1.750.000" },
  { id: 8, username: "Phuquy***99", prize: "8.900.000" },
];

// Quà thưởng hiển thị ở modal bước 3 — chỉnh lại khi có số liệu thật.
export const REWARD_TITLE = "CHÚC MỪNG BẠN";
export const REWARD_DESCRIPTION_TEMPLATE = (winTotal: number) =>
  `Kết thúc trải nghiệm! Tổng thắng {${winTotal}}.\nHệ thống xin tặng quý khách phần thưởng`;
export const REWARD_ITEM_LABEL = "Tặng ngay 29.000";
export const REWARD_ITEM_SUBLABEL = "Quà tân thủ";

// 24h tính bằng giây, giữ đúng ý nghĩa "23:59:59" trên thiết kế.
export const REWARD_CLAIM_WINDOW_SECONDS = 24 * 60 * 60;
